import { Input } from "@chakra-ui/react";
import moment from "moment";
import { useEffect, useState } from "react";
import { LoanCar } from "../../../modals/LoanCar";
import { getAvailableLockBoxes } from "../../../Services/LockBoxService";

require("./PickUpTime.css");

interface PickUpTimeProps {
  preDateSelected: string | undefined;
  setTimeSelected: Function;
  preTimeSelected: string | null;
  setLockBox: Function;
  preLockBoxSelected: LoanCar | null;
  setLockBoxAvailable: Function;
  setShowLoader: Function;
}

export default function PickUpTime(props: PickUpTimeProps) {
  const [isAfter, setIsAfter] = useState(false);
  const [isLockBoxAvailable, setIsLockBoxAvailable] = useState(true);

  useEffect(() => {
    if (props.preTimeSelected) {
      var day = moment().zone("GMT");
      var splitTime = props.preTimeSelected.split(/:/);
      day
        .hours(parseInt(splitTime[0]))
        .minutes(parseInt(splitTime[1]))
        .seconds(0)
        .milliseconds(0);
      setIsAfter(day.isAfter(moment().hours(14), "hours"));

      if (day.isAfter(moment().hours(14), "hours")) {
        props.setLockBoxAvailable(false);
        props.setShowLoader(true);
        checkLoanBoxAvailability();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.preTimeSelected]);

  const checkLoanBoxAvailability = async () => {
    const lockBoxes = await getAvailableLockBoxes(
      props.preDateSelected ? moment(props.preDateSelected) : moment()
    );

    setIsLockBoxAvailable(lockBoxes.length > 0);
    props.setLockBoxAvailable(lockBoxes.length > 0);

    props.setLockBox(lockBoxes[0]);
    props.setShowLoader(false);
  };

  const timeChange = (event: any) => {
    let t = event.target.value;
    props.setTimeSelected(t);
  };

  return (
    <div className="time-picker">
      <Input
        onChange={timeChange}
        defaultValue={props.preTimeSelected ? props.preTimeSelected : ""}
        placeholder="Select Date and Time"
        size="md"
        type="time"
      />
      {isAfter && (
        <p>
          <br></br>
          You have selected an after hour time for pick up.
          <br></br>
          {isLockBoxAvailable ? (
            "You will be assigned a lock box if available."
          ) : (
            <span style={{ color: "red" }}>
              No Lock Box Available. Please select a different date.
            </span>
          )}
        </p>
      )}
    </div>
  );
}
